import template from '../../templates/Home/keyword.template';
import Component from '../../core/component';

export default class Keyword extends Component {
    constructor(data) {
        super(template, data);
    }
}
